import {jQuery as $, lodash as _} from 'lib/shim';



const NAME = 'organism-contact-panel',
	SELECTOR = '.'+NAME;


class OrganismContactPanel {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
            this._$element = $element;
            this._$content = this._$element.find('.contact-panel-content').first();
            this._$closedContent = this._$element.find('.contact-panel-closed').first();
            this._$openButton = this._$closedContent.find('.closed-text').first();
            this._$closeButton = this._$content.find('.close-button').first();

			this._prime();
		}

		return $element;
	}

    _prime() {
	    let closedContentWidth = 0,
	        closedContentHeight = 0;

		closedContentWidth = this._$closedContent.outerWidth();
		this._$openButton.css('width', closedContentWidth);
		this._$closedContent.css('height', closedContentWidth);

	    this._$closeButton.on('click', () => {
		    closedContentWidth = this._$closedContent.outerWidth();
		    this._$openButton.css('width', closedContentWidth);

		    this._$closedContent.finish();

            this._$content.fadeOut(250, () => {
                this._$closedContent.animate({width: 'toggle'});
            });
        });

	    this._$openButton.on('click', () => {
		    closedContentWidth = this._$closedContent.outerWidth();
		    closedContentHeight = this._$closedContent.outerHeight();
		    this._$openButton.css('width', closedContentWidth);
		    this._$closedContent.css('height', closedContentWidth);

            this._$content.finish();

            this._$closedContent.animate({width: 'toggle'}, 250, 'linear', () => {
                this._$content.fadeIn();
            });
        })
    }
}

export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new OrganismContactPanel(app, $this));
	});

	return $elements;
}
